import { injectChannelController } from '@monofe/worker/util/interface/channel';
import {
    IContainer,
    injectConfigCache,
    injectFetch,
    injectLog,
    injectProgressPromise,
} from '../../interface';
import { injectMessageInstantiator } from '../../message/interface/instantiator';
import { injectRegexSerializer } from '../../util';
import type { IServiceWorkerClient } from '../interface';
import type { IServiceWorkerController } from '../interface/controller';
import ServiceWorker from './worker';

async function controller(container: IContainer): Promise<IServiceWorkerController> {
    const deps = {
        log: injectLog(container),
        fetcher: await injectFetch(container),
        promiser: injectProgressPromise(container),
        config: await injectConfigCache(container),
        regexParser: injectRegexSerializer(container),
        message: injectMessageInstantiator(container),
        channelController: injectChannelController(container),
    };

    let activeWorker: IServiceWorkerClient | undefined;

    return {
        start: (url: string, scope: string) => {
            activeWorker?.stop();
            activeWorker = ServiceWorker(deps, url, scope);
            activeWorker.start();
            return activeWorker;
        },
        active: () => activeWorker,
        terminate: () => {
            activeWorker?.stop();
            activeWorker = undefined;
        },
    };
}

export default controller;
